import styled from "styled-components";
import PropTypes from "prop-types";

import { Radii, Spacing, MediaQueries } from "@paclife/plds.tokens";
import Typography from "common/Typography/Typography";

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 1px 3px rgba(38, 38, 38, 0.2);
    border-radius: ${Radii.soft};
    padding: ${Spacing[24]};

    :hover {
        box-shadow: 0px 4px 15px rgba(196, 142, 142, 0.2);
    }
    margin-bottom: ${Spacing[24]};
    @media (min-width: ${MediaQueries.md}) {
        padding: ${Spacing[40]};
    }
`;

const Title = styled(Typography)`
    margin-bottom: ${Spacing[16]};
`;

const Card = ({ className, children, title, id }) => {
    return (
        <Wrapper className={className}>
            <Title variant="h2" id={id} display="block" bold>
                {title}
            </Title>
            {children}
        </Wrapper>
    );
};

export default Card;

Card.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

Card.defaultProps = {
    className: undefined
};
